// Copyright (c) 2025 Audere, All Rights Reserved

import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { ProjectDetailsProps } from "../types/projects";
import { createStyleSheet } from "../utils/styles";

import folderOpenUrl from "../../assets/folder_open.svg";
import { theme } from "../../theme";
import { useCallback } from "react";

const ProjectDetails = (props: ProjectDetailsProps) => {
  const { projectDetails, handleEditProject } = props;
  const { t } = useTranslation("ProjectDetails");

  const handleEdit = useCallback(() => {
    handleEditProject();
  }, [handleEditProject]);

  return (
    <Stack sx={styles.container}>
      <Stack flexDirection="row" gap={1}>
        <Box
          component="img"
          src={folderOpenUrl}
          sx={styles.projectDetailsFolderImg}
          alt="Folder Open"
        />
        <Typography variant="body1bold" sx={{ color: theme.palette.text.secondary }}>
          {projectDetails?.projectName}
        </Typography>
      </Stack>
      <Button variant="contained" sx={styles.editButton} onClick={handleEdit}>
        {t("common:edit")}
      </Button>
    </Stack>
  );
};

export default ProjectDetails;

const styles = createStyleSheet({
  container: {
    p: theme.spacing(1.5),
    px: theme.spacing(2),
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    background: theme.palette.common.white,
    boxShadow: 0,
    borderBottom: 1,
    borderBottomColor: "grey.300",
  },
  editButton: {
    p: theme.spacing(1.5),
    px: theme.spacing(5),
  },
  projectDetailsFolderImg: { height: 20, objectFit: "contain" },
});
